(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name crewing.controller:CrewingRightPanelCtrl
     *
     * @description
     *
     */
    angular
        .module('crewing')
        .controller('CrewingRightPanelCtrl', CrewingRightPanelCtrl);

    function CrewingRightPanelCtrl($scope, EventManagerService, SlideInPanelService, CrewingHelper, MessageService, CommonMasterData, PopupManager) {
        var _panelName = 'crewing.right.panel';
        $scope.model = {
            blockDetails: SlideInPanelService.getData(_panelName),
            trainingPrograms: null,
            trainingProgramDetails: null,
            selectedTrainingProgram: null,
            selectedTrainingProgramDetails: null,
            selectedFlightLegId: null,
            selectedTrainingSlotId: null,
            selectedCrewProfileId: null,
            selectedCrewRole: null,
            selectedResult: null,
            selectedModule: null,
            isExpiryUpdatable: false,
            allModules: [],
            allCourses: [],
            crewRoleCol: [],
            allResults: [{name: 'PASS'}, {name: 'FAIL'}],
            selectedCourse: null,
            isTrainingProgramDisable: false,
            isTrainerTraineeDisable: true,
            accordion: {
                first: {
                    isOpen: true
                },
                second: {
                    isOpen: false
                },
                third: {
                    isOpen: false
                }
            },
            remarks: null,
            checkIntimeReset : false,
            checkInDateStr : null,
            checkInTimeStr : null
        };

        EventManagerService.registerEventListener(EventManagerService.EVENT.PANEL.DATA_CHANGED, onPanelDataChange);

        function onPanelDataChange(panelName) {
            if (panelName === _panelName) {
                $scope.model.blockDetails = SlideInPanelService.getData(_panelName);
                $scope.model.isTrainerTraineeDisable = true;
                $scope.model.isExpiryUpdatable = false;

                if ($scope.model.blockDetails.isTraining) {
                    $scope.model.selectedTrainingSlotId = $scope.model.selectedFlightLegId = $scope.model.blockDetails.adaptedFlightEventDetails &&
                        $scope.model.blockDetails.adaptedFlightEventDetails[0].id;
                    $scope.model.isTrainingProgramDisable = true;

                } else if(!!$scope.model.blockDetails.adaptedFlightEventDetails){
                    if( $scope.model.blockDetails.adaptedFlightEventDetails[0].type==='FLIGHT'){
                    	$scope.model.selectedFlightLegId = $scope.model.blockDetails.adaptedFlightEventDetails[0].id;
                    	$scope.model.isTrainingProgramDisable = false;
                    }else if($scope.model.blockDetails.adaptedFlightEventDetails[0].type==='EVENT'){
                    	$scope.model.selectedEventId  = $scope.model.blockDetails.adaptedFlightEventDetails[0].id;
                    	$scope.model.isTrainingProgramDisable = true;
                    }
                }

                $scope.model.selectedCrewProfileId = $scope.model.blockDetails && $scope.model.blockDetails.adaptedAssignedCrewDetails &&
                    $scope.model.blockDetails.adaptedAssignedCrewDetails[0].crewProfileId;

                if (!!$scope.model.selectedFlightLegId || !!$scope.model.selectedTrainingSlotId) {
                    getTrainings();
                }
            }
        }

        $scope.onUpdateClick = function () {
        	var selectedFlightDetail = null;
        	if($scope.model.selectedFlightLegId !=null){
        		selectedFlightDetail = _.find($scope.model.blockDetails.adaptedFlightEventDetails, {id: $scope.model.selectedFlightLegId});
        	}

        	if(!!selectedFlightDetail){
        		var flightStartDateTime = selectedFlightDetail.startTime;
                var flightEndDateTiem = selectedFlightDetail.endTime;
                if (moment(flightStartDateTime, "DD/MM/YYYY HH:mm").isBefore(moment($scope.model.blockDetails.checkInDateStr + " " + $scope.model.blockDetails.checkInTimeStr, "DD/MM/YYYY HH:mm"))) {
                    MessageService.warning(MessageService.MESSAGES.CREWING.EDIT_BLOCK_ERROR_01);
                    return false;
                }
                else if (moment($scope.model.blockDetails.checkoutDateStr + " " + $scope.model.blockDetails.checkoutTimeStr, "DD/MM/YYYY HH:mm").isBefore(moment(flightEndDateTiem, "DD/MM/YYYY HH:mm"))) {
                    MessageService.warning(MessageService.MESSAGES.CREWING.EDIT_BLOCK_ERROR_02);
                    return false;
                }
                else {
                    onUpdate(false);
                }
        	}


        };

        $scope.onFlightClick = function (data) {
            $scope.model.isTrainerTraineeDisable = true;
            if(data.type === 'EVENT'){
            	$scope.model.selectedTrainingSlotId = null;
            	$scope.model.selectedFlightLegId = null;
            	$scope.model.selectedEventId = data.id;
            	$scope.model.selectedTrainingProgram = null;
            	$scope.model.isTrainingProgramDisable = true;
            	$scope.model.selectedTrainingProgramDetails = null;
            }else {
            	if ($scope.model.blockDetails.isTraining) {
                    $scope.model.selectedTrainingSlotId = data.id;
                    $scope.model.selectedFlightLegId = null;
                } else {
                	$scope.model.selectedTrainingSlotId = null;
                    $scope.model.selectedFlightLegId = data.id;
                }
            	$scope.model.isTrainingProgramDisable = false;
            	$scope.model.selectedEventId = null;
            	$scope.model.selectedTrainingProgram = _.find($scope.model.trainingPrograms, {trainingProgCode: data.trainingPro});
            	$scope.model.selectedTrainingProgramDetails = null;
            	getTrainingProgramDetails();
            }
            getTrainings();
            setTrainingCategoryForCrews();
        };

        $scope.onCrewClick = function (crewProfileId) {
            $scope.model.selectedCrewProfileId = crewProfileId;
            getTrainerTrainee();
        };

        $scope.onUpdateTrainingDetails = function () {
            var flightStartDateTime = $scope.model.blockDetails.adaptedFlightEventDetails[0].startTime;
            var flightEndDateTiem = $scope.model.blockDetails.adaptedFlightEventDetails[$scope.model.blockDetails.adaptedFlightEventDetails.length - 1].endTime;
            if (moment(flightStartDateTime, "DD/MM/YYYY HH:mm").isBefore(moment($scope.model.blockDetails.checkInDateStr + " " + $scope.model.blockDetails.checkInTimeStr, "DD/MM/YYYY HH:mm"))) {
                MessageService.warning(MessageService.MESSAGES.CREWING.EDIT_BLOCK_ERROR_01);
                return false;
            }
            else if (moment($scope.model.blockDetails.checkoutDateStr + " " + $scope.model.blockDetails.checkoutTimeStr, "DD/MM/YYYY HH:mm").isBefore(moment(flightEndDateTiem, "DD/MM/YYYY HH:mm"))) {
                MessageService.warning(MessageService.MESSAGES.CREWING.EDIT_BLOCK_ERROR_02);
                return false;
            }
            else {
              var continueOveride = false;
            	updateTrainingDetails(continueOveride);
            }


        };

        $scope.upDateTrainerTrainee = function () {

        	setTrainingCheckingTimes();
        	if($scope.model.selectedCrewRole.trainerTypeCode == 'TNE') {
        		updateCheckInTime(false);
        	} else {
        		updateTrainerTrainee();
        	}
        };

        $scope.onTrainingChange = function () {
            getTrainingProgramDetails();
        };

        $scope.updateResult = function (scope) {
            if (scope.passFailForm.$valid && !!$scope.model.selectedResult) {
                var crew = _.find($scope.model.blockDetails.assignedCrewDetailDTOs, {crewProfileId: $scope.model.selectedCrewProfileId});
                if ($scope.model.blockDetails.isTraining) {
                    var selectedTraining = _.find($scope.model.blockDetails.scheduleTrainingDetails, {trainingSlotId: $scope.model.selectedTrainingSlotId});
                    CrewingHelper.updateExpiryBlock(
                        selectedTraining,
                        crew,
                        $scope.model.selectedResult && $scope.model.selectedResult.name,
                        $scope.model.remarks,
                        function (updateResponse) {
                            if (updateResponse.success) {
                                MessageService.success('Result successfully updated');
                                EventManagerService.notifyEventListeners(EventManagerService.EVENT.PANEL.RELOAD_PANEL_DATA, _panelName);
                            } else {
                                MessageService.error('Update operation unsuccessful');
                            }
                        },
                        function (msg) {
                            MessageService.error(msg);
                        }
                    );
                } else {
                    var selectedFlight = _.find($scope.model.blockDetails.scheduleFlightLegDetails, {flightLegId: $scope.model.selectedFlightLegId});
                    CrewingHelper.updateExpiryFlight(
                        selectedFlight,
                        crew,
                        $scope.model.selectedResult && $scope.model.selectedResult.name,
                        $scope.model.remarks,
                        $scope.model.validationNo,
                        function (updateResponse) {
                            if (updateResponse.success) {
                                MessageService.success('Result successfully updated');
                            }
                        },
                        function (msg) {
                            MessageService.error(msg);
                        }
                    );
                }
            }
        };

        function upDateTrainerTrainee(){
        	 var crew = _.find($scope.model.blockDetails.assignedCrewDetailDTOs, {crewProfileId: $scope.model.selectedCrewProfileId});
             var param = {
                 trainingProgramId: $scope.model.selectedTrainingProgram.trainingProgramId,
                 trainingProgramDetailId: $scope.model.selectedTrainingProgramDetails.trainingProgramDetailId,
                 trainingSlotId: $scope.model.selectedTrainingSlotId,
                 crewProfileId: $scope.model.selectedCrewProfileId,
                 type: $scope.model.blockDetails.isTraining ? 'SLOT' : 'FLIGHT',
                 assignedAsType: ($scope.model.selectedCrewRole && $scope.model.selectedCrewRole.trainerTypeCode) || null,
                 crewScheduleBlockId: $scope.model.blockDetails.crewScheduleBlockId,
                 version: getVersion(crew),
                 crewScheduleTrainingSlotId: getSlotId(crew),
                 crewSchdFlightLegId: crew && crew.crewSchdFlightLegId,
                 selectedFlightLegId: $scope.model.selectedFlightLegId,
                 isTraining: $scope.model.blockDetails.isTraining
             };
             CrewingHelper.updateTrainerTrainee(param,
                 function (response) {
                     if (response.success) {
                         crew.trainrerTraineeType = ($scope.model.selectedCrewRole && $scope.model.selectedCrewRole.trainerTypeDesc) || null;
                         EventManagerService.notifyEventListeners(EventManagerService.EVENT.PANEL.RELOAD_PANEL_DATA, _panelName);
                         MessageService.success(MessageService.MESSAGES.CREWING.TRAINING_DETAILS_UPDATE_SUCCESS);
                     }
                 },
                 function (msg) {
                     MessageService.error(msg);
                 }
             );
        }

        function updateTrainingDetails(continueOveride){
        	if (!!$scope.model.selectedTrainingProgram){
                if(!$scope.model.selectedTrainingProgramDetails){
                    MessageService.warning('Program Detail cannot be blank.');
                    return false;
                }
            }
            var pic = 'Y';
            var crewSchdBlockId = $scope.model.blockDetails.crewScheduleBlockId;
            var type = $scope.model.blockDetails.isTraining ? 'SLOT' : 'FLIGHT';
            var slotId = $scope.model.blockDetails.isTraining ? $scope.model.selectedTrainingSlotId : $scope.model.selectedFlightLegId;
            var selected;
            if ($scope.model.blockDetails.isTraining) {
                selected = _.find($scope.model.blockDetails.scheduleTrainingDetails, {trainingSlotId: $scope.model.selectedTrainingSlotId});
            } else {
                selected = _.find($scope.model.blockDetails.scheduleFlightLegDetails, {flightLegId: $scope.model.selectedFlightLegId});
            }
            var version = !!selected ? selected.version : 0;

            CrewingHelper.updateTrainingProgram(
                $scope.blockDetails.crewProfileId,
                continueOveride,
                pic,
                crewSchdBlockId,
                type,
                slotId,
                ($scope.model.selectedTrainingProgram && $scope.model.selectedTrainingProgram.trainingProgramId) || null,
                ($scope.model.selectedTrainingProgramDetails && $scope.model.selectedTrainingProgramDetails.trainingProgramDetailId) || null,
                version,
                function (updateResponse) {
                    if (updateResponse.success) {
                        MessageService.success(MessageService.MESSAGES.CREWING.UPDATE_SUCCESS);
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.PANEL.RELOAD_PANEL_DATA, _panelName);
                    } else {
                        MessageService.error(MessageService.MESSAGES.CREWING.UPDATE_FAIL);
                    }
                },
                function (msg) {
                    MessageService.error(msg);
                });
        }

        function updateCheckInTime(isContinueIllegal) {
            $scope.model.blockDetails.continueIllegal = isContinueIllegal;

            if($scope.model.checkInDateStr != null && $scope.model.checkInTimeStr != null){
            	$scope.model.blockDetails.checkInDateStr = $scope.model.checkInDateStr;
            	$scope.model.blockDetails.checkInTimeStr = $scope.model.checkInTimeStr;
            }

            CrewingHelper.updateCheckInCheckout($scope.model.blockDetails,
                function (res) {
            		editBlockTimeResponseAction(res);
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }

        function editBlockTimeResponseAction(editParingResponse) {
            if (editParingResponse.success) {
            	upDateTrainerTrainee();
                var updated = CrewingHelper.getCrewIdsFromBlockDetails($scope.model.blockDetails);
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.CREWING.UPDATE_SCHEDULE_FOR_CREWS, updated);
                SlideInPanelService.toggle(_panelName, $scope.model.blockDetails);
            } else if (!!editParingResponse) {
                if (!!editParingResponse.regulationMap) {
                    var regulationDetailParam = {
                        regulationMap: editParingResponse.adaptedRegulationMap,
                        onAcceptPassBackParam: editParingResponse
                    };
                    PopupManager.openModal('REGULATION_DETAILS', regulationDetailParam, closeRegulationPopupForPairing);
                }
            }
        }

        function closeRegulationPopupForPairing(params) {
            if (!!params) {
            	updateCheckInTime(true);
            }
        }

        function setTrainingCheckingTimes(){

        	if($scope.model.selectedTrainingProgram == null ){
            	$scope.model.checkInDateStr = null;
    	        $scope.model.checkInTimeStr = null;
    	        return;
            }

	        var checkInDate = moment($scope.model.blockDetails.actualBlockStartDate + " " +$scope.model.blockDetails.actualBlockStartTime,
    		"DD/MM/YYYY HH:mm")

	        checkInDate.add( ( -1 * $scope.model.selectedTrainingProgram.defaultCheckIn ), 'minutes');

	        var checkInDateStr = checkInDate.format('DD/MM/YYYY');
	        var checkInTimeStr = checkInDate.format('HH:mm');
	        $scope.model.checkInDateStr = checkInDateStr;
	        $scope.model.checkInTimeStr = checkInTimeStr;

        }

        function getVersion(crew) {
            var version = null;
            if (!!crew) {
                version = ($scope.model.blockDetails.isTraining) ? crew.crewSchdTrainingSlotVersion : crew.crewSchdFlightLegVersion;
            }
            return version;
        }

        function getSlotId(crew) {
            var slot = null;
            if (!!crew) {
                slot = ($scope.model.blockDetails.isTraining) ? crew.crewSchdTrainingSlotId : crew.crewSchdFlightLegId;
            }
            return slot;
        }

        function onUpdate(isContinueIllegal) {
            $scope.model.blockDetails.continueIllegal = isContinueIllegal;
            CrewingHelper.updateCheckInCheckout($scope.model.blockDetails,
                function (res) {
                    editPairingResponseAction(res);
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }

        function setPassFailInfo() {
            var selected;
            if ($scope.model.blockDetails.isTraining) {
                selected = _.find($scope.model.blockDetails.scheduleTrainingDetails, {trainingSlotId: $scope.model.selectedTrainingSlotId});
            } else {
                selected = _.find($scope.model.blockDetails.scheduleFlightLegDetails, {flightLegId: $scope.model.selectedFlightLegId});
            }

            if (!!selected) {
                $scope.model.isExpiryUpdatable = selected.expiryUpdatable;
                var crew = _.find(selected.assignedCrewTrainingDetails, {crewProfileId: $scope.model.selectedCrewProfileId});
                if (!!crew && crew.result) {
                    $scope.model.selectedResult = {name: crew.result};
                } else {
                    $scope.model.selectedResult = null;
                }
            } else {
                $scope.model.selectedResult = null;
            }
        }

        function setRoleForSelectedCrew() {
            var crew = _.find($scope.model.blockDetails.assignedCrewDetailDTOs, {crewProfileId: $scope.model.selectedCrewProfileId});
            if (!!crew && !!crew.trainrerTraineeType) {
                $scope.model.selectedCrewRole = _.find($scope.model.crewRoleCol, {trainerTypeCode: crew.trainrerTraineeTypeCode});
                setPassFailInfo();
            } else {
                $scope.model.selectedCrewRole = null;
            }
        }

        function getTrainerTrainee() {
            if (!!$scope.model.selectedCrewProfileId && !!$scope.model.selectedTrainingProgram && $scope.model.selectedTrainingProgram.trainingProgramId)
                CommonMasterData.getTrainerTraineeTypes(
                    $scope.model.selectedCrewProfileId,
                    $scope.model.selectedTrainingProgram.trainingProgramId,
                    function (types) {
                        $scope.model.crewRoleCol = types;
                        setRoleForSelectedCrew();
                    },
                    function (error) {
                        MessageService.error(error);
                    }
                )
        }


        function editPairingResponseAction(editParingResponse) {
            if (editParingResponse.success) {
                MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_PAIRING_SUCCESS);
                if (editParingResponse.otherBlockIllegal) {
                    MessageService.warning(MessageService.MESSAGES.CREWING.ASSIGN_TRAINING_OTHER_BLOCKS_ILLEGAL);
                }
                var updated = CrewingHelper.getCrewIdsFromBlockDetails($scope.model.blockDetails);
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.CREWING.UPDATE_SCHEDULE_FOR_CREWS, updated);
                SlideInPanelService.toggle(_panelName, $scope.model.blockDetails);
            } else if (!!editParingResponse) {
                if (!!editParingResponse.regulationMap) {
                    var regulationDetailParam = {
                        regulationMap: editParingResponse.adaptedRegulationMap,
                        onAcceptPassBackParam: editParingResponse
                    };
                    PopupManager.openModal('REGULATION_DETAILS', regulationDetailParam, onCloseRegulationPopupForPairing);
                }
            }
        }

        function onCloseRegulationPopupForPairing(params) {
            if (!!params) {
                onUpdate(true);
            }
        }


        function resetPreviousTrainingCategoryInfo() {
            angular.forEach($scope.model.blockDetails.adaptedAssignedCrewDetails, function (crewColVal) {
                if (crewColVal.fieldName == 'Trainee/Trainer') {
                    crewColVal.fieldValues[0].field_0 = '';
                }
            });
        }

        function setTrainingCategoryForCrews() {
            resetPreviousTrainingCategoryInfo();
            var selectedFlight = _.find($scope.model.blockDetails.scheduleFlightLegDetails, {flightLegId: $scope.model.selectedFlightLegId});
            if (!!selectedFlight) {
                angular.forEach(selectedFlight.assignedCrewTrainingDetails, function (crew) {
                    var crewColVal = $scope.model.blockDetails.adaptedAssignedCrewDetails;
                    var tmp = _.find(crewColVal, function (c) {
                        return c.fieldName == 'Trainee/Trainer' && c.fieldValues[0].crewProfileId == crew.crewProfileId
                    });
                    if (!!tmp) {
                        tmp.fieldValues[0].field_0 = crew.trainingCategory;
                    }
                });
            }
        }

        function setSelectedTraining() {
            var selectedFlight = _.find($scope.model.blockDetails.scheduleFlightLegDetails, {flightLegId: $scope.model.selectedFlightLegId});
            if (!!selectedFlight) {
                $scope.model.selectedTrainingProgram = _.find($scope.model.trainingPrograms, {trainingProgramId: selectedFlight.trainingProgramId});
                if (!!$scope.model.selectedTrainingProgram) {
                    getTrainingProgramDetails();
                } else {
                    $scope.model.selectedTrainingProgramDetails = null;
                }
            }
        }

        function getTrainings() {
            if ($scope.model.blockDetails.isTraining) {
                var selected = _.find($scope.model.blockDetails.scheduleTrainingDetails, {trainingSlotId: $scope.model.selectedTrainingSlotId});
                if (!!selected) {
                    $scope.model.trainingPrograms = [{
                        trainingProgCode: selected.trainingProgramCode,
                        trainingProgramId: selected.trainingProgramId
                    }];
                    $scope.model.selectedTrainingProgram = $scope.model.trainingPrograms[0];
                    getTrainingProgramDetails();
                }
            } else {
                CrewingHelper.getTrainingProgramsByCategoryCode('FLT',
                    function (trainings) {
                        $scope.model.trainingPrograms = trainings;
                        setSelectedTraining();
                    },
                    function (msg) {
                        MessageService.error(msg);
                    }
                );
            }


        }

        function setSelectedTrainingProgramDetails() {
            var selected;
            if ($scope.model.blockDetails.isTraining) {
                selected = _.find($scope.model.blockDetails.scheduleTrainingDetails, {trainingSlotId: $scope.model.selectedTrainingSlotId});
            } else {
                selected = _.find($scope.model.blockDetails.scheduleFlightLegDetails, {flightLegId: $scope.model.selectedFlightLegId});
            }

            if (!!selected) {
                $scope.model.selectedTrainingProgramDetails = _.find($scope.model.trainingProgramDetails, {trainingProgramDetailId: selected.trainingProgramDetailId})
                if (!!$scope.model.selectedTrainingProgramDetails) {
                    $scope.model.isTrainerTraineeDisable = false;
                    if (!!$scope.model.selectedCrewProfileId) {
                        getTrainerTrainee();
                    }
                } else {
                    $scope.model.isTrainerTraineeDisable = true;
                }
            }
        }

        function getTrainingProgramDetails() {
            if (!!$scope.model.selectedTrainingProgram) {
                CommonMasterData.getTrainingProgramDetails($scope.model.selectedTrainingProgram,
                    function (programDetails) {
                        $scope.model.trainingProgramDetails = programDetails;
                        setSelectedTrainingProgramDetails();
                    },
                    function (msg) {
                        MessageService.error(msg);
                    })
            }else{
                $scope.model.selectedTrainingProgramDetails = null;
            }
        }

    }
}());
